import { createSvgIcon } from "@mui/material";

const InsertRowBottom = createSvgIcon(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  <path d="M12 13C14.7614 13 17 15.2386 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 15.2386 9.23858 13 12 13ZM13 15H11V16.999L9 17V19L11 18.999V21H13V18.999L15 19V17L13 16.999V15ZM20 3C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H20ZM5 5V9H19V5H5Z"></path>,
  "InsertRowBottom"
);

export default InsertRowBottom;
